<template>
  <b-container>
    <h1>Les cabinets</h1>
    <b-row class="justify-content-center">
      <Cabinet
        v-for="cabinet in cabinets"
        :key="cabinet.name"
        :name="cabinet.name"
        :photos="cabinet.photos"
        :description="cabinet.description"
        :horaire="cabinet.horaire"
        :adresse="cabinet.adresse"
        :logo="cabinet.logo"
      ></Cabinet>
    </b-row>
    <div class="map">
      <h2>S'y rendre</h2>
      <Map />
    </div>
  </b-container>
</template>

<style scoped>
.map {
  margin-top: 30px;
}
</style>

<script>
import Cabinet from "../components/Cabinet";
import Map from "../components/Map";
export default {
  data() {
    return {
      cabinets: [
        {
          logo: "aurore.jpg",
          photos: [
            "image23.jpg",
            "image5.jpg",
            "image41.jpg",
            "image42.jpg",
            "image27.jpg",
			"image43.jpg",
            "image10.jpg",
            "image11.jpg",
          ],
          description:
            "Le cabinet d’orthoptie fait partie du pôle de santé interprofessionnel universitaire de Saint Martin d’Hères,  avec lequel nous partageons des protocoles et des projets innovants  (l'ambition étant de travailler collectivement à la réduction des inégalités sociales de santé) Nous disposons de trois salles de rééducation et d’une salle d’examen de vue.  Nous pouvons effectuer tous les types de bilans et examens dans ce cabinet. Il est accessible PMR (personne à mobilité réduite) (sauf la salle d’examen de vue).",
          name: "Le cabinet de l’Aurore à St Martin d’Hères",
          horaire: "Du lundi au vendredi de 9h à 19h.",
          adresse:
            "Le cabinet est situé sur la place piétonne Frida Kahlo, au numéro 9, derrière l’immeuble en demi-cercle ou se trouve la pharmacie / le coiffeur/ la pizzeria.",
        },
        {
          logo: "vif.jpg",
          photos: ["image44.jpg"],
          description:
            "Le cabinet d’orthoptie de Vif fait partie de la Maison de Santé pluri-professionnel d’Uriol (comprenant médecins généralistes, kinésithérapeutes, orthophoniste et ergothérapeute).  Nous pouvons effectuer tous types de bilans, dépistages et rééducations visuelles. (attention pas de dépistage de la rétinopathie diabétique, ni de consultation de renouvellement de la correction optique)",
          name: "Le cabinet d'orthoptie à Vif",
          horaire: "Ouvert les lundi et vendredi.",
          adresse: "La MSP d'Uriol se situe au 12 route du stade à Vif, face à l'école Champollion",
        },
      ],
    };
  },
  components: {
    Cabinet,
    Map,
  },
};
</script>
